import $ from "jquery";
import winwheel from "winwheeljs";
import fb from "@bd-core/firebase";
// import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";
import BD_Component from "@bd-core/bd-component";
import compile from "../utils/handlerbars-helper";
import {
    // getRoomStatus,
    getPlayers,
    getRoomStatus,
    getUserFromId,
    isLeader,
} from "@bd-stores/game-progress";
import {
    getTeamConnectorState,
    maybeUpdateRoomStatus,
    updateTeamConnectorState,
    setIsTeamConnectorFinished,
    setRoomFinished,
    setRoomStarted,
    // maybeUpdateRoomStatus,
    // setTimeSpentToFinish,
} from "@bd-core/firebase-actions";
import { getState } from "@bd-stores/store";
import { isTestMode } from "@bd-utils/test-mode";
import { getCurrentPageId, getCurrentPageType } from "@bd-stores/user-progress";

export class RoomTeamConnector extends BD_Component {
    constructor() {
        super();

        this.id = "teamconnector_room";
        this.templateID = "teamconnector_room-template";

        this.elms = {
            spinBtn: ".js-spin-btn",
            closeBtn: ".js-close-question-popup",
            categories: ".js-categories",
            toggleCategories: ".js-toggle-categories",
            btnContinue: ".js-continue",
            /* Inside question popup */
            categoryName: ".js-category-name",
            playerName: ".js-player-name",
            questionText: ".js-question-text",
            questionPopup: ".js-question-popup",
            questionPopupTitle: ".js-question-popup-title",
            questionTimer: ".js-tc-question-timer",
            backBtn: ".js-result-back",
            teamConnector: ".teamconnector",
            readyCheck: ".js-readytc-btn",
        };
        this.tcData = {};

        this.objWheel = {};
        this.wheelSpinning = false;
        this.questionTimer = 0;
        this.spinAudio = new Audio(
            "https://res.cloudinary.com/drtnbid6h/video/upload/v1641880582/tick_mpn0xo.mp3",
        );
        this.fbListener = null;

        this.totalSpin = 12;

        this._events = this.getEvents();
        this.fbListeners = [];
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.spinBtn,
                handler: this.triggerSpin,
            },
            {
                event: "click",
                selector: elms.btnContinue,
                handler: this.onClickContinue,
            },
            {
                event: "click",
                selector: elms.toggleCategories,
                handler: this.toggleCategories,
            },
            {
                event: "click",
                selector: elms.closeBtn,
                handler: this.closeQuestionPopup,
            },
            {
                event: "click",
                selector: elms.backBtn,
                handler: this.goToPrevPage,
            },
            {
                event: "click",
                selector: elms.readyCheck,
                handler: this.iamReady,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setupWheel();
        this.setGameState();

        /** Events */
        this.fbListener =
            this.fbListener ??
            fb.onValue(
                `${fb.teamAttributesPath}/teamconnector`,
                this.maybeStartSpin.bind(this),
            );

        this.listenPlayersState();
    }

    setModifiedData() {
        const gameProgress = getState().gameProgress;
        const isTcFinished = gameProgress.isTeamConnectorFinished;
        const tcData = this._data;
        const { spinning_sound } = tcData;

        if (spinning_sound) {
            this.spinAudio = new Audio(spinning_sound);
        }

        const newTcData = {
            ...tcData,
            isTeamConnectorFinished: isTcFinished,
        };

        return newTcData;
    }

    render() {
        const tcData = this.setModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, tcData);

        $(".app").html(html);

        if (isTestMode()) {
            this.maybeRoomIsFinished();
        }
        if (isLeader()) {
            $(this.elms.spinBtn).prop("disabled", false);
        } else {
            $(this.elms.spinBtn).prop("disabled", true);
        }
    }

    /**
     * Setup TC Wheel
     */
    setupWheel() {
        const wheelSegments = [];
        const categories = this._data.categories;
        categories.forEach((category) => {
            wheelSegments.push({
                cat_id: category.cat_id,
                text: category.cat_name,
                image: category.attr.icon,
                textFillStyle: category.attr.text_color
                    ? category.attr.text_color
                    : "white",
                fillStyle: "transparent",
            });
        });

        this.objWheel = new winwheel({
            canvasId: "teamconnectorWheel",
            drawMode: "segmentImage",
            drawText: false,
            numSegments: wheelSegments.length, // Number of segments
            pointerAngle: -45,
            outerRadius: 220, // The size of the wheel.
            centerX: 250, // Used to position on the background correctly.
            centerY: 250,
            // textLineWidth: 2,
            strokeStyle: "rgba(255,255,255,.3)", // Segment line colour. Again segment lines only drawn if this is specified.
            lineWidth: 1,
            innerRadius: 80,
            textOrientation: "curved",
            textFontSize: 30,
            textFontWeight: 900,
            textFontFamily: '"Sentico Sans DT",sans-serif',
            textFillStyle: "white", // Font size.
            textDirection: "reversed",
            segments: wheelSegments,
            animation: {
                type: "spinToStop",
                duration: 5,
                spins: 6,
                callbackFinished: this.getQuestionFromCategory.bind(this),
                callbackSound: () => {
                    this.spinAudio.pause();
                    this.spinAudio.currentTime = 0;
                    this.spinAudio.play().catch(() => {});
                },
            },
        });

        let loadedImg = new Image();

        loadedImg.src =
            "/wp-content/themes/mission-tomorrow2/assets/images/teamconnector-wheel.png";
        this.objWheel.wheelImage = loadedImg; // Make wheelImage equal the loaded image object.
        this.objWheel.draw(); // Also call draw function to render the wheel.
        loadedImg.onload = function () {};

        this.objWheel.draw();
    }

    setGameState() {
        const elms = this.elms;
        const tcData = this.setModifiedData();
        const { isTeamConnectorFinished } = tcData;
        const $spinBtn = $(elms.spinBtn);
        $(".app__back").hide();
        const $backBtn = $(".js-back-to-main-room");

        getTeamConnectorState().then((tcData) => {
            const data = tcData.val();

            // @ts-ignore
            this.totalSpin = data?.totalSpin;
            $(".js-total-spin").text(this.totalSpin);
        });

        if (isTeamConnectorFinished) {
            $spinBtn.attr("disabled", "disabled");
            $backBtn.removeClass("hidden");
        } else {
            $backBtn.addClass("hidden");
        }
    }

    goToPrevPage() {
        $(this.elms.teamConnector).removeClass("is-active");
    }

    iamReady(e, el) {
        const $el = $(el);
        $el.toggleClass("is-waiting-ready");

        //if all players ready close popup (by removing class "is-open" on $(".js-readiness-popup")) and start timer
    }

    resetWheel() {
        this.objWheel.stopAnimation(false); // Stop the animation, false as param so does not call callback function.
        this.objWheel.rotationAngle = 0; // Re-set the wheel angle to 0 degrees.
        this.objWheel.draw(); // Call draw to render changes to the wheel.

        this.wheelSpinning = false;

        updateTeamConnectorState({
            spinning: false,
        });
    }

    getQuestionFromCategory() {
        const categories = this._data.categories;
        const objCategory = categories.find(
            (cat) => cat.cat_id == this.tcData.catId,
        );
        const questions = objCategory?.questions || [];
        const objQuestion = questions.find(
            (question) => question.id == this.tcData.questionId,
        );
        const objPlayer = getUserFromId(this.tcData.playerTurn);

        const catName = objCategory?.cat_name || "";
        const question = objQuestion?.content || "There is no question here.";
        const playerName = objPlayer?.name || "No Name";

        this.showTheQuestion(playerName, question, catName);
    }

    showTheQuestion(playerName, question, categoryName) {
        const elms = this.elms;
        const is_leader = isLeader();
        if (is_leader) {
            $(this.elms.spinBtn).prop("disabled", false);
        }

        const $questionPopupTitle = $(elms.questionPopupTitle);
        const displaynameWrapper = $(elms.questionPopupTitle).find(
            ".displayName",
        );

        // if single player remove playername
        const players = getPlayers().filter((p) => p.isOnline);
        if (players.length === 1) {
            playerName = "";
        }

        if (displaynameWrapper.length > 0) {
            displaynameWrapper.html(playerName);
        } else {
            const wrapStr = $questionPopupTitle
                .html()
                .replace(
                    /{nickname}/g,
                    '<span class="displayName">{nickname}</span>',
                );
            $questionPopupTitle.html(wrapStr);

            let popupText = $questionPopupTitle.html();
            if (players.length === 1) {
                popupText = popupText.replace(", answer", "Answer");
            }

            const modifiedtxt = popupText.replaceAll("{nickname}", playerName);

            $questionPopupTitle.html(modifiedtxt);
        }

        $(elms.categoryName).html(categoryName);
        $(elms.questionText).find("p").html(question);

        this.startQuestionTimer();
        $(elms.questionPopup).addClass("is-open");
        this.checkStates();
        this.resetWheel();
    }

    startQuestionTimer() {
        const elms = this.elms;
        const popUpTimer = this._data.popup_timer;
        const cfgMinutes = popUpTimer || 3;
        const getCurrentTime = () => new Date(Date.now()).getTime();
        const deadline = new Date(
            getCurrentTime() + cfgMinutes * 60 * 1000,
        ).getTime();

        if (this.questionTimer) {
            clearInterval(this.questionTimer);
            const txtSeconds = "";
            $(elms.questionTimer).text(`${txtSeconds}`);
        }

        //TODO: this interval should stopped when move from team connector page

        // @ts-ignore
        this.questionTimer = setInterval(() => {
            const time = deadline - getCurrentTime();
            const seconds = Math.floor((time / 1000) % 60);
            const minutes = Math.floor((time / 1000 / 60) % 60);

            const txtSeconds = `${seconds} Seconds`;
            const txtMinutes = minutes > 0 ? `${minutes} Minutes ` : "";

            $(elms.questionTimer).text(`${txtMinutes}${txtSeconds}`);

            if (time <= 0) {
                clearInterval(this.questionTimer);
                $(elms.questionTimer).text("");
                $(elms.closeBtn).trigger("click");
            }
        }, 1000);
    }

    toggleCategories() {
        $(this.elms.categories).toggleClass("is-toggled");
    }

    closeQuestionPopup() {
        $(this.elms.questionPopup).removeClass("is-open");
        clearInterval(this.questionTimer);
    }

    /* On button spin clicked */
    triggerSpin() {
        const roomID = this.roomId;
        const roomStatus = getRoomStatus(roomID);

        if (
            (roomStatus === "is-status-completed" || this.totalSpin <= 0) &&
            !isTestMode()
        ) {
            alert("You've completed this challenge.");
            return;
        }

        const objWheel = this.objWheel;
        const states = this.getLocalStates();
        const categories = this._data.categories;

        /**
         * @returns {BD_TC_Category}
         */
        const getRandomCategory = () => {
            const availableCategories = categories.filter(
                (cat) => !states.categories.includes(cat.cat_id),
            );
            const randIndex = Math.floor(
                Math.random() * availableCategories.length,
            );

            return availableCategories?.[randIndex] || availableCategories[0];
        };

        const getRandomQuestion = () => {
            const category = getRandomCategory();
            const questions = category.questions.filter(
                (question) => !states.questions.includes(question.id),
            );

            const randIndex = Math.floor(Math.random() * questions.length);

            const randomQuestion = questions[randIndex];

            return {
                id: randomQuestion.id,
                cat_id: category.cat_id,
            };
        };

        const getRandomPlayer = () => {
            const players = getPlayers().filter(
                (p) => !states.players.includes(p.userId),
            );

            const randomPlayerIndex = Math.floor(
                Math.random() * players.length,
            );
            return players[randomPlayerIndex];
        };

        const choosenQuestion = getRandomQuestion();
        const player = getRandomPlayer();

        let segmentIndex = 0;
        let categoryId = 0;
        let foundSegmentIndex = objWheel.segments.findIndex(
            (segment) => segment && segment.cat_id == choosenQuestion.cat_id,
        );

        if (foundSegmentIndex > -1) {
            segmentIndex = foundSegmentIndex;
            categoryId = choosenQuestion.cat_id;
        }

        const stopAt = objWheel.getRandomForSegment(segmentIndex);
        // Important thing is to set the stopAngle of the animation before stating the spin.
        objWheel.animation.stopAngle = stopAt;

        const totalSpin = states?.totalSpin;
        const updatedTotalSpin = totalSpin - 1;
        this.totalSpin = updatedTotalSpin;

        $(this.elms.spinBtn).prop("disabled", true);

        this.wheelSpinning = true;

        const onSuccess = () => {
            $(".js-total-spin").text(updatedTotalSpin);
            this.maybeRoomIsFinished();
        };
        const onFailur = () => {
            $(this.elms.spinBtn).prop("disabled", false);
        };

        updateTeamConnectorState({
            catId: categoryId,
            playerTurn: player.userId,
            stopAt: stopAt,
            questionId: choosenQuestion.id,
            spinning: true,
            totalSpin: updatedTotalSpin,
        })
            .then(onSuccess)
            .catch(onFailur);
    }

    onClickContinue() {
        this.closeQuestionPopup();
        this.triggerSpin();
    }

    updateTotalSpin(tcData) {
        if (!tcData) return;

        this.totalSpin = tcData?.totalSpin;
        $(".js-total-spin").text(this.totalSpin);
    }

    /* Check whether spinner was triggered from firebase */
    maybeStartSpin(snapshot) {
        const objWheel = this.objWheel;
        const tc = snapshot.val();
        if (!tc || !tc.spinning) return;

        /* Stop spinning */
        if (!tc?.spinning) {
            return;
        }

        this.closeQuestionPopup();

        //Set TC
        this.tcData = tc;

        this.updateTotalSpin(tc);

        objWheel.animation.stopAngle = tc.stopAt;
        objWheel.startAnimation();
        $(this.elms.spinBtn).prop("disabled", true);
    }

    maybeRoomIsFinished() {
        const roomID = this.roomId;

        if (this.totalSpin <= 0 || isTestMode()) {
            setIsTeamConnectorFinished(true);
            setRoomFinished(roomID);
            maybeUpdateRoomStatus(roomID, "is-status-completed");
        }
    }

    /*
     * LOCAL STORAGE STATES
     ***************************************************
     */
    checkStates() {
        const categories = this._data.categories;
        const tcData = this.tcData;
        const states = this.getLocalStates();
        let isUpdate = false;

        if (!states.questions.includes(tcData.questionId)) {
            states.questions.push(tcData.questionId);
            isUpdate = true;
        }

        if (!states.players.includes(tcData.playerTurn)) {
            states.players.push(tcData.playerTurn);
            isUpdate = true;
        }

        //check players
        const players = getPlayers().filter(
            (p) => !states.players.includes(p.userId),
        );

        if (!players.length) {
            states.players = [];
            isUpdate = true;
        }

        //check categories
        categories.forEach((category) => {
            const availableQuestions = category.questions.filter(
                (question) => !states.questions.includes(question.id),
            );

            if (
                !availableQuestions.length &&
                !states.categories.includes(category.cat_id)
            ) {
                states.categories.push(category.cat_id);
                isUpdate = true;
            }
        });

        const availableCategories = categories.filter(
            (category) => !states.categories.includes(category.cat_id),
        );

        if (!availableCategories.length) {
            states.categories = [];
            states.questions = [];
            isUpdate = true;
        }

        states.totalSpin = this.totalSpin;

        return isUpdate ? this.updateLocalStates(states) : false;
    }

    getLocalStates() {
        let states = Storage.get("states", {});
        return (
            states?.tc || {
                questions: [],
                players: [],
                categories: [],
                totalSpin: 12,
            }
        );
    }

    updateLocalStates(_states) {
        let states = Storage.get("states", {});
        states.tc = _states;
        return Storage.set("states", states);
    }

    checkReadiness(snapshot) {
        const currentPageId = getCurrentPageId();
        const currentPageType = getCurrentPageType();
        if (currentPageType !== "teamconnector_room") {
            return;
        }

        const data = snapshot.val();
        const players = Object.keys(data).map((key) => data[key]);
        // @ts-ignore
        const isAllReady = players
            .filter((p) => p.isOnline)
            .every((obj) => obj.hasSeenGameIntro);

        if (players.length > 1 && !isAllReady && !isTestMode()) {
            this.handleTeamConnectorUnready(players);
        } else {
            setRoomStarted(currentPageId);
            this.handleTeamConnectorReady();
        }
    }

    listenPlayersState() {
        if (this.fbListeners.length) {
            this.fbListeners.forEach((fn) => fn.call());
        }

        const playerListener = fb.onValue(
            fb.playersPath,
            this.checkReadiness.bind(this),
        );
        this.fbListeners.push(playerListener);
    }

    handleTeamConnectorReady = () => {
        const $popUp = $(".js-readiness-popup");
        $popUp.removeClass("is-open");
    };

    handleTeamConnectorUnready = (players) => {
        const $popUp = $(".js-readiness-popup");
        const $playerList = $popUp.find(".playerLists");

        let playerHtml = "";
        players.forEach((player) => {
            playerHtml += `
            <div class="gamePlayer__item js-player-item ${
                player.hasSeenGameIntro ? "is-ready" : ""
            }" player-id="${player.userId}">
                <div class="gamePlayer__avatar" style="background-image: url('${
                    player.avatarURL
                }');">
                    <div class="gamePlayer__status"></div> 
                </div>
                <div class="gamePlayer__name"> 
                    ${player.name}
                </div>
            </div>
            `;
        });

        $playerList.html(playerHtml);
        $popUp.addClass("is-open");
    };
}
